<template>
    <div class="row">
        <div class="col">
            <card>
                <card-content>
                    <form @submit.prevent="submit">
                        <div class="row">
                            <div class="col col-6">
                                <h5>
                                    <translate render-html="true">Machen Sie uns ein Angebot. <strong>Hier und
                                        jetzt.</strong></translate>
                                </h5>
                                <p>
                                    <translate>Bieten Sie hier Ihren realistischen Bestpreis zu Ihrer bestmöglichen
                                        Lieferzeit. Den Zuschlag für das Projekt erhält der zuverlässigste Anbieter-
                                        gemessen an den drei Faktoren Qualität, Liefertreue und Preisattraktivität.
                                    </translate>
                                </p>
                                <p>
                                    <translate>Bitte geben Sie für jede Stückzahl Ihre Lieferzeit (in Kalendertagen ab
                                        Bestelleingang) und Ihren Gesamtpreis (für alle Bauteile in Euro, netto und
                                        inkl.
                                        Versandkosten) ein.
                                    </translate>
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <table class="table table--stripped">
                                    <thead>
                                    <tr>
                                        <th>
                                            <translate>Bauteile</translate>
                                        </th>
                                        <th>
                                            <translate>Lieferzeit</translate>
                                        </th>
                                        <th>
                                            <translate>Preis</translate>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-if="askForQuote.bid_rounds[0].lotqty_1"
                                        :class="{'selected' : askForQuote.bid_rounds[0].lotqty_1 === this.askForQuote.producer_order.amount}">
                                        <td> {{ askForQuote.bid_rounds[0].lotqty_1 }}</td>
                                        <td> {{ offer.lot_delivery_1 }}</td>
                                        <td> {{ offer.lot_offer_1 }}</td>
                                    </tr>
                                    <tr v-if="askForQuote.bid_rounds[0].lotqty_2"
                                        :class="{'selected' : askForQuote.bid_rounds[0].lotqty_2 === this.askForQuote.producer_order.amount}">
                                        <td> {{ askForQuote.bid_rounds[0].lotqty_2 }}</td>
                                        <td> {{ offer.lot_delivery_2 }}</td>
                                        <td> {{ offer.lot_offer_2 }}</td>
                                    </tr>
                                    <tr v-if="askForQuote.bid_rounds[0].lotqty_3"
                                        :class="{'selected' : askForQuote.bid_rounds[0].lotqty_3 === this.askForQuote.producer_order.amount}">
                                        <td> {{ askForQuote.bid_rounds[0].lotqty_3 }}</td>
                                        <td> {{ offer.lot_delivery_3 }}</td>
                                        <td> {{ offer.lot_offer_3 }}</td>
                                    </tr>
                                    <tr v-if="askForQuote.bid_rounds[0].lotqty_4"
                                        :class="{'selected' : askForQuote.bid_rounds[0].lotqty_4 === this.askForQuote.producer_order.amount}">
                                        <td> {{ askForQuote.bid_rounds[0].lotqty_4 }}</td>
                                        <td> {{ offer.lot_delivery_4 }}</td>
                                        <td> {{ offer.lot_offer_4 }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </form>
                </card-content>
            </card>
        </div>
    </div>
</template>

<script>
import CardContent from '@partfactory/Shared/Card/CardContent';
import Card from '@partfactory/Shared/Card/Card';

export default {
    name: 'ComponentOfferTable',
    components: {Card, CardContent},
    props: {
        askForQuote: Object,
    },
    data() {
        let rejectDialog = false;

        const bidRoundIndex = this.askForQuote.bid_rounds.length - 1;

        const offer = {
            lot_offer_1: this.$currency(this.askForQuote.bid_rounds[bidRoundIndex].bid_round_members[0]?.lot_offer_1),
            lot_offer_2: this.$currency(this.askForQuote.bid_rounds[bidRoundIndex].bid_round_members[0]?.lot_offer_2),
            lot_offer_3: this.$currency(this.askForQuote.bid_rounds[bidRoundIndex].bid_round_members[0]?.lot_offer_3),
            lot_offer_4: this.$currency(this.askForQuote.bid_rounds[bidRoundIndex].bid_round_members[0]?.lot_offer_4),
            lot_delivery_1: this.askForQuote.bid_rounds[bidRoundIndex].bid_round_members[0]?.lot_delivery_1,
            lot_delivery_2: this.askForQuote.bid_rounds[bidRoundIndex].bid_round_members[0]?.lot_delivery_2,
            lot_delivery_3: this.askForQuote.bid_rounds[bidRoundIndex].bid_round_members[0]?.lot_delivery_3,
            lot_delivery_4: this.askForQuote.bid_rounds[bidRoundIndex].bid_round_members[0]?.lot_delivery_4,
        };

        return {rejectDialog, offer};
    },
    computed: {
        offerValidUntil() {
            let offerValidiy = this.$moment(this.askForQuote.bid_rounds[0].ending_at).add(this.askForQuote.bid_rounds[0].p_custom_offer_validity, 'days');
            if (!offerValidiy.isBusinessDay() || offerValidiy.isHoliday()) {
                offerValidiy = offerValidiy.nextBusinessDay();
            }
            return offerValidiy;
        },
        deliveryWish() {
            // const deliveryDate = this.$moment(this.askForQuote.bid_rounds[0].ask_for_quote.delivery_date);
            // return this.$moment(this.askForQuote.bid_rounds[0].ending_at).businessDiff(deliveryDate) + ' Kalendertage';
            return this.askForQuote.bid_rounds[0].delivery_days_for_producer + ' ' + this.$gettext('Kalendertage');
        },
    },
};
</script>
